import request from "@/utils/request";

/**
 * 注册
 * @param data
 * @param urlSuffix 可选值 registerByTenantCode / registerByHost
 * @returns {*}
 */
export function registerApi(data, urlSuffix) {
  return request({
    // registerByTenantCode
    url: `/system/user/${urlSuffix}`,
    method: "post",
    data,
  });
}
// 登录
export function loginApi(data) {
  return request({
    url: "/system/user/loginByTenantCode",
    method: "post",
    data,
  });
}

// 二级域名登录
export function loginByHost(data) {
  return request({
    url: '/system/user/loginByHost',
    method: 'post',
    data
  })
}

// 登出
export function logoutApi() {
  return request({
    url: "/system/user/logout",
    method: "post",
  });
}
